import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Style from './UpsellProgressBar.module.scss';

const UpsellProgressBar = ({ currentStep }) => {
  const {
    landingPage_breadcrumb1: breadcrumb1,
    landingPage_breadcrumb2: breadcrumb2,
    landingPage_breadcrumb3: breadcrumb3,
  } = window.Language;
  const steps = [breadcrumb1, breadcrumb2, breadcrumb3];
  return (
    <div className={Style.container}>
      {_.map(steps, (stepLabel, idx) => {
        const stepClasses = [Style.step];
        const filled = currentStep >= idx;
        const completed = currentStep > idx;
        if (filled) stepClasses.push(Style.filled);
        if (completed) stepClasses.push(Style.completed);
        return (
          <div
            data-test="progress-bar-step"
            key={`step-${idx}`}
            className={classNames(stepClasses)}
          >
            {idx > 0 && <div className={Style.connector} />}
            <div className={Style.anchor}>
              <div className={Style.label}>{stepLabel}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default UpsellProgressBar;

UpsellProgressBar.defaultProps = {
  currentStep: 0,
};

UpsellProgressBar.propTypes = {
  currentStep: PropTypes.number,
};
